const RentOption = require("./RentOption");
const OptionBase = require("./OptionBase");
const {OPTION_TYPE} = require("./RentOptionConstant");
const QuantityOption = require("./QuantityOption");

class MultipleChoiceOption extends RentOption {

    constructor({
                    id = '',
                    name = '',
                    required = false,
                    enabled = true,
                    value = null,
                    option = [],
                } = {}) {
        super({id, name, required, enabled, value});
        this.option = Array.isArray(option) ? option.map((o) => new OptionBase(o)) : [];
        this.type = OPTION_TYPE.MULTIPLE_CHOICE;
        if(value){
            this.value = new OptionBase({...value})
        }

        if(required && !value && this.option.length > 0){
            this._value = this.option.sort(OptionBase.compare)[0]
        }
    }

    addPrice(priceBase = 0){
        if(!this._value || !this._value.addPrice){
            return 0
        }
        return this._value.addPrice(priceBase)
    }

    get value() {
        return this._value;
    }

    set value(value) {
        if(!this.required && !value){
            this._value = null
        }

        if(this.option.some((o) => o.isSame(value))){
            this._value = value
        }
    }

    validate(attribute) {

        if (attribute === undefined) {
            const attributes = Object.keys(this);
            try {
                attributes.map(attribute => {
                    if (!this._validate(attribute)) {
                        throw "validation error"
                    }
                });
            } catch (e) {
                return false
            }
            return true
        }

        return this._validate(attribute)
    }

    _validate(attribute) {

        try {
            switch (attribute) {
                case 'id':
                    return (typeof this[attribute] === 'string');
                default:
                    return false
            }
        } catch (e) {
            console.error('Validating MultipleChoiceOption with error:', e, attribute);
            return false
        }
    }

    toFirestore() {
        const data = super.toFirestore()
        return {
            ...data,
            value: this._value && this._value.toFirestore ? this._value.toFirestore() : null,
            option: this.option.map(o => o.toFirestore()),
            type: this.type
        }
    }

    static fromFirestore(fsSnap) {

        let data = {};
        if (fsSnap) {
            Object.keys(fsSnap).forEach((key) => {
                // the firestore object is not null
                if (fsSnap[key]) {
                    switch (fsSnap[key].type){
                        case OPTION_TYPE.MULTIPLE_CHOICE:
                            data[key] = new MultipleChoiceOption({...fsSnap[key], id: key})
                            break;
                        case OPTION_TYPE.QUANTITY:
                            data[key] = new QuantityOption({...fsSnap[key], id: key})
                            break;
                        default:
                            data[key] = new RentOption({...fsSnap[key], id: key})
                    }
                }
            });
        }

        return data
    }
}

module.exports = MultipleChoiceOption;